// FIXIT: Replace imageUrl and the note or caption when real files are in
// src/assets/. Then set placeholder to false. Do not add prices until they exist.

export const merchProducts = [
  {
    name: "Field tee",
    note: "Placeholder. Swap in the shirt photo and a real description.",
    imageUrl: "",
    placeholder: true
  },
  {
    name: "Field hat",
    note: "Placeholder. Swap in the hat photo and a real description.",
    imageUrl: "",
    placeholder: true
  },
  {
    name: "Crewneck",
    note: "Placeholder. Swap in the crewneck photo and a real description.",
    imageUrl: "",
    placeholder: true
  },
  {
    name: "Tote",
    note: "Placeholder. Swap in the tote photo and a real description.",
    imageUrl: "",
    placeholder: true
  }
];

export const shootFrames = [
  {
    imageUrl: "",
    caption: "Coming Soon",
    placeholder: true
  },
  {
    imageUrl: "",
    caption: "Coming Soon",
    placeholder: true
  },
  {
    imageUrl: "",
    caption: "Coming Soon",
    placeholder: true
  }
];
